// src/services/orderService.js
import { orderApi } from '../utils/apiConfig';

export const orderService = {
  getDeliveryConfig: async () => {
    try {
      const response = await orderApi.get('/api/orders/get/delivery');
      return response.data;
    } catch (error) {
      console.error("Error fetching delivery config:", error);
      // Fallback default values in case API fails
      return { freeDeliveryAbove: 0, deliveryFee: 0, codCharge: 0 };
    }
  },

  // Coupons API
  getActiveCoupons: async () => {
    try {
      const response = await orderApi.get('/api/coupons/status', {
        params: { status: 'ACTIVE' }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching active coupons:", error);
      return [];
    }
  },

  applyCoupon: async (couponCode) => {
    const response = await orderApi.post(`/api/cart/apply-coupon/${couponCode}`);
    return response.data;
  },

  removeCoupon: async () => {
    const response = await orderApi.delete('/api/cart/remove-coupon');
    return response.data;
  },

  // Place Order API
  placeOrder: async (orderData) => {
    const response = await orderApi.post('/api/orders/place', orderData);
    return response.data;
  },

  // Payment Verification API
  verifyPayment: async (paymentData) => {
    const response = await orderApi.post('/api/payment/verify', paymentData);
    return response.data;
  },

  // Orders Fetching APIs
  getMyOrders: async () => {
    try {
      const response = await orderApi.get('/api/orders/myOrders');
      return response.data;
    } catch (error) {
      console.error("Error fetching my orders:", error);
      throw error;
    }
  },

  getOrderDetails: async (globalOrderId) => {
    try {
      const response = await orderApi.get(`/api/orders/getbyorderId/${globalOrderId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching order details:", error);
      throw error;
    }
  },

  getOrderItemDetails: async (orderItemId) => {
    try {
      const response = await orderApi.get(`/api/orders/item/${orderItemId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching order item details:", error);
      throw error;
    }
  },

  // Cancellation APIs
  cancelOrder: async (orderId) => {
    try {
      // Handles both globalOrderId and subOrderId
      const response = await orderApi.put(`/api/orders/${orderId}/cancel`);
      return response.data;
    } catch (error) {
      console.error("Error cancelling order:", error);
      throw error;
    }
  },

  cancelOrderItem: async (orderItemId) => {
    try {
      const response = await orderApi.put(`/api/orders/item/${orderItemId}/cancel`);
      return response.data;
    } catch (error) {
      console.error("Error cancelling order item:", error);
      throw error;
    }
  },

  // NEW: Raise Issue / Return API
  raiseOrderItemIssue: async (orderItemId, issueData) => {
    try {
      const response = await orderApi.post(`/api/orders/item/${orderItemId}/issue`, issueData);
      return response.data;
    } catch (error) {
      console.error("Error raising order item issue:", error);
      throw error;
    }
  },

  // NEW: Live Sub-Order Delivery Tracking API Mapping
  getOrderTracking: async (subOrderId) => {
    try {
      const response = await orderApi.get(`/api/deliveryPartner/order/${subOrderId}/tracking`);
      return response.data;
    } catch (error) {
      console.error("Error fetching live tracking data:", error);
      return null;
    }
  }
};